/* Shopify validates the complete Message property at 200 Unicode code points.
 * The existing Filofax email flow stores the design URL in that same property.
 * Keep that serialization intact and budget for its exact selected-image suffix.
 */
(function () {
  'use strict';

  var MAX_MESSAGE_CHARACTERS = 200;
  var copy = {
    en: {
      label: 'Add a personal message*',
      help: 'The limit depends on your selected design. Spaces and line breaks count; some accented letters and emoji use more than one character.',
      choose: '{count} characters. Select a design to see the limit.',
      chooseSingular: '1 character. Select a design to see the limit.',
      counter: '{count} / {limit} characters · {remaining} remaining',
      overCounter: '{count} / {limit} characters · {over} over the limit',
      over: 'Your message is {over} characters over the limit for this design. Please shorten it before continuing.',
      overSingular: 'Your message is 1 character over the limit for this design. Please shorten it before continuing.',
      required: 'Please enter your message.'
    },
    de: {
      label: 'Persönliche Nachricht hinzufügen*',
      help: 'Das Limit hängt vom gewählten Design ab. Leerzeichen und Zeilenumbrüche zählen mit; manche Buchstaben mit Akzenten und Emojis zählen als mehrere Zeichen.',
      choose: '{count} Zeichen. Wählen Sie ein Design, um das Limit zu sehen.',
      counter: '{count} / {limit} Zeichen · {remaining} verbleibend',
      overCounter: '{count} / {limit} Zeichen · {over} über dem Limit',
      over: 'Ihre Nachricht überschreitet das Limit für dieses Design um {over} Zeichen. Bitte kürzen Sie sie, bevor Sie fortfahren.',
      required: 'Bitte geben Sie Ihre Nachricht ein.'
    },
    fr: {
      label: 'Ajoutez un message personnel*',
      help: 'La limite dépend du modèle choisi. Les espaces et les sauts de ligne comptent ; certaines lettres accentuées et certains emojis comptent pour plusieurs caractères.',
      choose: '{count} caractères. Choisissez un modèle pour voir la limite.',
      chooseSingular: '1 caractère. Choisissez un modèle pour voir la limite.',
      counter: '{count} / {limit} caractères · {remaining} restants',
      overCounter: '{count} / {limit} caractères · {over} en trop',
      over: 'Votre message dépasse la limite de ce modèle de {over} caractères. Veuillez le raccourcir avant de continuer.',
      overSingular: 'Votre message dépasse la limite de ce modèle de 1 caractère. Veuillez le raccourcir avant de continuer.',
      required: 'Veuillez saisir votre message.'
    },
    es: {
      label: 'Añade un mensaje personal*',
      help: 'El límite depende del diseño elegido. Los espacios y saltos de línea cuentan; algunas letras acentuadas y emojis cuentan como varios caracteres.',
      choose: '{count} caracteres. Elige un diseño para ver el límite.',
      chooseSingular: '1 carácter. Elige un diseño para ver el límite.',
      counter: '{count} / {limit} caracteres · {remaining} restantes',
      overCounter: '{count} / {limit} caracteres · {over} por encima del límite',
      over: 'Tu mensaje supera el límite de este diseño en {over} caracteres. Acórtalo antes de continuar.',
      overSingular: 'Tu mensaje supera el límite de este diseño en 1 carácter. Acórtalo antes de continuar.',
      required: 'Introduce tu mensaje.'
    },
    it: {
      label: 'AGGIUNGI UN MESSAGGIO PERSONALE*',
      help: 'Il limite dipende dal design selezionato. Gli spazi e gli a capo contano; alcune lettere accentate ed emoji contano come più caratteri.',
      choose: '{count} caratteri. Seleziona un design per vedere il limite.',
      chooseSingular: '1 carattere. Seleziona un design per vedere il limite.',
      counter: '{count} / {limit} caratteri · {remaining} rimanenti',
      overCounter: '{count} / {limit} caratteri · {over} oltre il limite',
      over: 'Il messaggio supera il limite di questo design di {over} caratteri. Accorcialo prima di continuare.',
      overSingular: 'Il messaggio supera il limite di questo design di 1 carattere. Accorcialo prima di continuare.',
      required: 'Inserisci il tuo messaggio.'
    }
  };

  function characterCount(value) {
    // Code points match Shopify's server validation, including astral emoji.
    return Array.from(value).length;
  }

  function init() {
    var field = document.getElementById('recipientMessage');
    var counter = document.getElementById('gift-message-counter');
    if (!field || !counter || window.FilofaxGiftMessage) return;

    var label = document.querySelector('label[for="recipientMessage"]');
    var help = document.getElementById('gift-message-help');
    var error = document.getElementById('gift-message-error');
    var locale = (document.documentElement.lang || field.dataset.locale || 'en').toLowerCase().split('-')[0];
    var strings = copy[locale] || copy.en;
    var showRequired = false;
    var composing = false;
    var announcementTimer;
    label.textContent = strings.label;
    help.textContent = strings.help;

    function format(template, values) {
      return template.replace(/\{(count|limit|remaining|over)\}/g, function (match, key) {
        return values[key];
      });
    }

    function state() {
      var image = document.querySelector('.giftImage.active img');
      // getAttribute deliberately matches the pre-existing jQuery .attr('src').
      var src = image && image.getAttribute('src');
      var suffix = src ? '[]https:' + src : '';
      var limit = src ? Math.max(0, MAX_MESSAGE_CHARACTERS - characterCount(suffix)) : null;
      var count = characterCount(field.value);
      return { count: count, limit: limit, remaining: limit === null ? null : Math.max(0, limit - count),
        over: limit === null ? 0 : Math.max(0, count - limit), suffix: suffix };
    }

    function update(immediate) {
      var current = state();
      var overTemplate = current.over === 1 && strings.overSingular ? strings.overSingular : strings.over;
      var chooseTemplate = current.count === 1 && strings.chooseSingular ? strings.chooseSingular : strings.choose;
      var message = current.over ? format(overTemplate, current) : showRequired && !field.value.trim() ? strings.required : '';
      var counterText = format(current.limit === null ? chooseTemplate : current.over ? strings.overCounter : strings.counter, current);
      // Keep typed and pasted text intact, including when a design reduces the budget.
      field.setCustomValidity(message);
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      error.textContent = message;
      error.hidden = !message;
      counter.textContent = counterText;
      counter.classList.toggle('gift-message-over', !!current.over);
      clearTimeout(announcementTimer);
      var announce = function () {
        document.getElementById('gift-message-status').textContent = message || counterText;
      };
      if (!composing) {
        if (immediate) announce();
        else announcementTimer = setTimeout(announce, 350);
      }
      return !message;
    }

    window.FilofaxGiftMessage = {
      validate: function () {
        showRequired = true;
        if (update(true)) return true;
        field.focus();
        return false;
      },
      serialize: function () { return field.value + state().suffix; }
    };

    field.addEventListener('input', function () { update(false); });
    field.addEventListener('compositionstart', function () { composing = true; clearTimeout(announcementTimer); });
    field.addEventListener('compositionend', function () { composing = false; update(false); });
    // Gift design selection/filtering uses delegated handlers and rebuilds slides.
    document.addEventListener('click', function (event) {
      if (event.target.closest('.giftImage, .filter')) {
        // Run after the existing delegated jQuery handler changes the selection.
        setTimeout(function () { update(true); }, 0);
      }
    });
    window.addEventListener('pageshow', function () { update(true); });
    update(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
